"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.onClickHandle = void 0;
var onClickHandle = function (redirectURL) {
    if (redirectURL) {
        window.open(decodeURIComponent(redirectURL), '_parent');
    }
};
exports.onClickHandle = onClickHandle;
